import React, { useState } from 'react';
import styled from 'styled-components';

const AnimatedExportButton = ({ onExportExcel, onExportPDF }) => {
  const [showExportMenu, setShowExportMenu] = useState(false);

  return (
    <StyledWrapper>
      <div className="relative">
        <button 
          className="button"
          type="button"
          onClick={() => setShowExportMenu(!showExportMenu)}
        >
          <span className="button__text">Export</span>
          <span className="button__icon">
            <svg viewBox="0 0 24 24" width={25} height={20} stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1={16} y1={13} x2={8} y2={13} />
              <line x1={16} y1={17} x2={8} y2={17} />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </span>
        </button>

        {/* Export Options Dropdown */}
        {showExportMenu && (
          <div className="absolute right-0 mt-2 w-25 bg-white border rounded-md shadow-lg z-[9999] export-dropdown">
            <button
              onClick={() => {
                onExportExcel();
                setShowExportMenu(false);
              }}
              className="export-option excel-option"
            >
              <svg viewBox="0 0 24 24" width={16} height={16} stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1={16} y1={13} x2={8} y2={13} />
                <line x1={16} y1={17} x2={8} y2={17} />
              </svg>
              Excel
            </button>
            <button
              onClick={() => {
                onExportPDF();
                setShowExportMenu(false);
              }}
              className="export-option pdf-option"
            >
              <svg viewBox="0 0 24 24" width={16} height={16} stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <path d="M16 13H8" />
                <path d="M16 17H8" />
                <path d="M10 9H8" />
              </svg>
              PDF
            </button>
          </div>
        )}
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .button {
    position: relative;
    width: 110px;
    height: 36px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border: 1px solid #17795E;
    background-color: #209978;
    overflow: hidden;
    border-radius: 4px;
  }

  .button, .button__icon, .button__text {
    transition: all 0.3s;
  }

  .button .button__text {
    transform: translateX(16px);
    color: #fff;
    font-weight: 600;
    font-size: 13px;
  }

  .button .button__icon {
    position: absolute;
    transform: translateX(76px);
    height: 100%;
    width: 28px;
    background-color: #17795E;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button .button__icon svg {
    width: 20px;
    fill: #fff;
    stroke: #fff;
  }

  .button:hover {
    background: #17795E;
  }

  .button:hover .button__text {
    color: transparent;
  }

  .button:hover .button__icon {
    width: 108px;
    transform: translateX(0);
  }

  .button:active .button__icon {
    background-color: #146c54;
  }

  .button:active {
    border: 1px solid #146c54;
  }

  /* Export Dropdown Styles */
  .export-dropdown {
    animation: slideDown 0.2s ease-out;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .export-option {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 12px;
    text-align: left;
    font-size: 14px;
    border: none;
    background: none;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #374151;
  }

  .export-option:hover {
    background-color: #f3f4f6;
    color: #111827;
  }

  .excel-option:hover {
    background-color: #dcfce7;
    color: #166534;
  }

  .pdf-option:hover {
    background-color: #fef3c7;
    color: #92400e;
  }

  .export-option:first-child {
    border-radius: 6px 6px 0 0;
  }

  .export-option:last-child {
    border-radius: 0 0 6px 6px;
  }

  .export-option svg {
    flex-shrink: 0;
  }
`;

export default AnimatedExportButton;